import { useSearchParams } from "react-router-dom";

const BotonPage = () => {
  const [searchParams] = useSearchParams();
  const audicode = searchParams.get("ac");
  // console.log("audicode", searchParams.get("ac")); // ▶ URLSearchParams {}
  return (
    <div style={{ width:"100%", textAlign: "center" }}>
      <a
        href={`${process.env.REACT_APP_DOMAIN}/audi-forms/salesforce/configurador?ac=${audicode}`}
        target="_blank"
        rel="noreferrer"
        className="button button-home button-cta--congifurador"
      >
        Quiero este Audi
      </a>
    </div>
  );
};

export default BotonPage;
